import Glide from '@glidejs/glide';
import Carousel from './Carousel';

/**
 * @description search carousel implementation
 */
export default class EditorialCarousel extends Carousel {
    prefs() {
        return {
            ...super.prefs()
        };
    }

    init() {
        super.init();
        this.configureGlide(this.ref('self').els[0]);
    }

    /**
     * @param {string} name
    */
    getCssVar(name) {
        return getComputedStyle(document.documentElement).getPropertyValue(name);
    }

    /**
     * @param {string} nextCarousel
    */
    glide(nextCarousel) {
        const smBreakpoint = Number(this.getCssVar('--sm').replace('px', ''));
        const mdBreakpoint = Number(this.getCssVar('--md').replace('px', ''));


        return new Glide(nextCarousel, {
            perView: 3.5,
            rewind: false,
            type: 'slider',
            arrows: 'body',
            breakpoints: {
                [mdBreakpoint]: {
                    perView: 2
                },
                [smBreakpoint]: {
                    perView: 2
                },
                ['540']: {
                    perView: 1.8
                }
            }
        }).mount({
            DisableControls: function (Glide, Components, Events) {
                const PREV_CONTROL_SELECTOR = '[data-glide-dir="<"]';
                const NEXT_CONTROL_SELECTOR = '[data-glide-dir=">"]';
                const component = {
                    buildAfter() {
                        this.prevBtn = Components.Html.root.querySelector(PREV_CONTROL_SELECTOR);
                        this.nextBtn = Components.Html.root.querySelector(NEXT_CONTROL_SELECTOR);
                    },
                    handleDisable() {
                        const perView = Glide.settings.perView;
                        const slidesCount = Components.Html.slides.length;
                        this.prevBtn.hidden = (Glide.index <= 0);
                        this.nextBtn.hidden = (Glide.index >= slidesCount - perView);
                    }
                };

                Events.on('build.after', () => {
                    component.buildAfter();
                    component.handleDisable();
                });

                Events.on('run.after', () => {
                    component.handleDisable();
                });

                return component;
            }
        }
        );
    }

    /**
     * @param {any} nextCarousel
    */
    configureGlide(nextCarousel) {
        if (typeof Glide === 'undefined') {
            return;
        }
        this.glideInstance = this.glide(nextCarousel);
        return this.glideInstance;

    }

    reset () {
        super.refresh();
    }

    destroy () {
        this.glideInstance.destroy();
    }
}